import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { func, number, shape } from 'prop-types';
import { Link, useParams } from 'react-router-dom';

// Components
import { ChevronRightRounded } from '@mui/icons-material';
import { ProductIndicatorBadge } from 'common';

// helpers
import { getSelectionURI } from 'utils/helpers/url';

// styles
import {
  chevronRightStyles,
  chipStylesSelectedStyles,
  chipStylesStyles,
  inactiveCountSelectedStyles,
  inactiveCountStyles,
  labelStyles,
  linkStyles,
  selectedListItemStyles,
  titleStyles,
} from './Selector.styles';

const Selector = ({
  selectedIndex,
  data,
  index,
  resetCardFilters,
  setFilters,
  setMobileDrawerOpen,
  style,
}) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
  const { currentAffiliateId, dataCompanyId, viewBy } = useParams();

  const { nameShort, activeAuthorizationsCount, inactiveAuthorizationsCount, proprietary } =
    data.selectorsData[index];

  const handleOnClick = idx => {
    resetCardFilters();
    setFilters({ name: 'selectedIndex', value: idx });
    setFilters({
      name: 'activeTab',
      value: 'baseProducts',
    });
    if (!lgUp) {
      setMobileDrawerOpen(true);
    }
  };

  // probably create the style object here first
  const linkStylesObject = {
    ...linkStyles(theme),
    ...(index === selectedIndex ? selectedListItemStyles(theme) : {}),
    ...style,
  };

  const titleStylesObject = {
    ...titleStyles(theme),
  };

  const labelStylesObject = {
    ...labelStyles(theme),
  };

  const chevronRightStylesObject = {
    ...chevronRightStyles(theme),
  };

  const chipStylesObject =
    index === selectedIndex ? chipStylesSelectedStyles(theme) : chipStylesStyles(theme);

  const inactiveCountStylesObject =
    index === selectedIndex ? inactiveCountSelectedStyles(theme) : inactiveCountStyles(theme);

  return (
    <Box
      component={Link}
      key={nameShort}
      onClick={() => handleOnClick(index)}
      sx={linkStylesObject}
      to={`/affiliate/${currentAffiliateId}/${dataCompanyId}/loading-management/supplier-authorizations/${viewBy}/${getSelectionURI(
        data.selectorsData[index]
      )}`}
    >
      <Typography sx={titleStylesObject}>{nameShort}</Typography>
      <ChevronRightRounded sx={chevronRightStylesObject} />

      <Typography className="active-chip" sx={chipStylesObject}>
        {activeAuthorizationsCount}
      </Typography>
      <Box sx={labelStylesObject}>Active Authorizations</Box>

      <Typography className="inactive-count" sx={inactiveCountStylesObject}>
        {inactiveAuthorizationsCount}
      </Typography>
      <Typography sx={{ fontSize: '0.875rem', gridColumn: '2 / 4' }}>
        Inactive Authorizations
      </Typography>
      {viewBy === 'product' && (
        <Box sx={{ position: 'absolute', right: 24, top: 52 }}>
          <ProductIndicatorBadge proprietary={proprietary} />
        </Box>
      )}
    </Box>
  );
};

Selector.propTypes = {
  data: shape({}).isRequired,
  index: number.isRequired,
  resetCardFilters: func.isRequired,
  selectedIndex: number,
  setFilters: func.isRequired,
  setMobileDrawerOpen: func.isRequired,
  style: shape({}).isRequired,
};

Selector.defaultProps = {
  selectedIndex: undefined,
};

export default Selector;
